(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('AudioIbqDeleteController',AudioIbqDeleteController);

    AudioIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Audio'];

    function AudioIbqDeleteController($uibModalInstance, entity, Audio) {
        var vm = this;

        vm.audio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Audio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
